import { ResponsiveFeature } from '@/common/components/ResponsiveFeature'
import { FeatureName } from '@/features.config'
import { Box } from '@mui/material'
import { ReactNode, Suspense } from 'react'

interface PageLayoutProps {
  /** Feature flag for responsive behavior */
  feature: FeatureName
  /** Page content */
  children: ReactNode
  /** Loading fallback for Suspense */
  loadingFallback?: ReactNode
}

/**
 * Standardized page layout component that provides consistent structure across all pages.
 *
 * Structure:
 * - MobileWarningBanner (when feature is not available on current viewport)
 * - Page content
 *
 * A page heads itself with the design-system `PageHeader` as its first child.
 *
 * @example
 * <PageLayout feature={FEATURES.TRAININGS}>
 *   <PageHeader title="Trainings" action={<Button>Add Training</Button>} />
 *   <TrainingsList />
 * </PageLayout>
 */
export const PageLayout = ({ feature, children, loadingFallback = null }: PageLayoutProps): JSX.Element => {
  return (
    <ResponsiveFeature feature={feature} loadingFallback={loadingFallback}>
      <Suspense fallback={loadingFallback}>
        <Box>{children}</Box>
      </Suspense>
    </ResponsiveFeature>
  )
}
